var _g, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 260,
    viewBox: "0 0 261 260",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20_1680)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40.724,
    y: 36,
    width: 180,
    height: 180,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41.224,
    y: 36.5,
    width: 179,
    height: 179,
    rx: 31.5,
    stroke: "#D9D9D9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.6081 111.33C81.6081 111.33 79.1725 109.575 82.0953 107.23L88.9049 101.141C88.9049 101.141 90.8534 99.0914 92.9135 100.877L155.753 148.453V171.267C155.753 171.267 155.722 174.85 151.125 174.454L81.6081 111.33Z",
    fill: "#2489CA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8051 126.036L81.6081 140.761C81.6081 140.761 79.9438 141.999 81.6081 144.212L89.1281 151.052C89.1281 151.052 90.9143 152.97 93.5529 150.788L110.724 137.767L97.8051 126.036Z",
    fill: "#1070B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.241 126.158L155.946 103.476L155.753 80.7838C155.753 80.7838 154.484 75.8313 150.252 78.409L110.724 114.385L126.241 126.158Z",
    fill: "#0877B9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.125 174.484C152.85 176.25 154.941 175.672 154.941 175.672L178.089 164.265C181.053 162.245 180.637 159.739 180.637 159.739V91.6222C180.637 88.6284 177.572 87.5933 177.572 87.5933L157.508 77.9218C153.124 75.2122 150.252 78.4089 150.252 78.4089C150.252 78.4089 153.946 75.75 155.753 80.7837V170.851C155.753 171.47 155.621 172.079 155.357 172.627C154.829 173.693 153.682 174.687 150.932 174.271L151.125 174.484Z",
    fill: "#3C99D4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20_1680",
    x: 0.723999,
    y: 0,
    width: 260,
    height: 260,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0367917 0 0 0 0 0.0348958 0 0 0 0 0.0484375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20_1680"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20_1680",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVs);
export default __webpack_public_path__ + "static/media/vs.265fc317585331f0c4af392a40a30ad6.svg";
export { ForwardRef as ReactComponent };